import { gql } from "@apollo/client";

export const GET_GUIDE_REVIEWS = gql`
    query getGuideReviews($month: Int!, $year: Int!) {
        getGuideReviews(month: $month, year: $year) {
            _id
            month
            year
            createdAt
            guide {
                _id
                profile {
                    firstName
                    lastName
                }
            }
        }
    }
`;

export const GET_MY_GUIDE_REVIEWS = gql`
    query getMyGuideReviews($month: Int!, $year: Int!) {
        getMyGuideReviews(month: $month, year: $year) {
            _id
            month
            year
            createdAt
            guide {
                _id
                profile {
                    firstName
                    lastName
                }
            }
        }
    }
`;

export const DELETE_GUIDE_REVIEW = gql`
    mutation deleteGuideReview($id: String!) {
        deleteGuideReview(id: $id)
    }
`;
